import React, { useState, useEffect, useRef } from "react";

const DropdownSelectableList = ({ items, selection, multiSelect = false, setItems }) => {
  const [selectedItems, setSelectedItems] = useState(
    multiSelect ? selection || [] : selection || null
  );
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setItems(selectedItems);
  }, [selectedItems]);

  // Cerrar el dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectItem = (item) => {
    if (multiSelect) {
      setSelectedItems((prevSelected) =>
        prevSelected.includes(item)
          ? prevSelected.filter((i) => i !== item)
          : [...prevSelected, item]
      );
    } else {
      setSelectedItems(item === selectedItems ? null : item);
      setOpen(false);
    }
  };

  const renderSelected = () => {
    if (multiSelect) {
      return selectedItems.length > 0 ? selectedItems.join(", ") : "Seleccionar...";
    } else {
      return selectedItems || "Seleccionar...";
    }
  };

  return (
    <div className="relative w-full max-w-xs" ref={dropdownRef}>
      {/* Botón principal */}
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-left flex justify-between items-center bg-white hover:bg-gray-50"
      >
        <span className="truncate text-gray-700">{renderSelected()}</span>
        <svg
          className={`w-4 h-4 ml-2 transform transition-transform ${
            open ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Lista desplegable */}
      {open && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-56 overflow-auto">
          {items.map((item) => {
            const isSelected = multiSelect
              ? selectedItems.includes(item)
              : selectedItems === item;

            return (
              <li
                key={item}
                onClick={() => handleSelectItem(item)}
                className={`px-3 py-2 cursor-pointer flex justify-between items-center ${
                  isSelected ? "bg-blue-100 text-blue-600" : "hover:bg-gray-100"
                }`}
              >
                <span>{item}</span>
                {isSelected && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-blue-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default DropdownSelectableList;
